module.exports = __webpack_public_path__ + "static/img/2.9ee3d46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/2.png
// module id = tssg
// module chunks = 0